module.exports = __webpack_public_path__ + "img/7.0418c6e1.jpg";